import { render } from "./ConfigTeam.vue?vue&type=template&id=2f380f50"
import script from "./ConfigTeam.vue?vue&type=script&lang=js"
export * from "./ConfigTeam.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__